import {ReactElement} from 'react';
import ReactDOMServer from 'react-dom/server';

/**
 * Returns an image url string for the svg element
 */
export function encodeSvgToDataUrl(svgElement: ReactElement): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    ReactDOMServer.renderToStaticMarkup(svgElement)
  )}`;
}
